import styled from 'styled-components'
import {
  Table as DefaultTable,
  FakeLinkButton,
  TableComponents,
} from '@sketch/components'

const { TableRow, TableCell } = TableComponents

export const ErrorWrapper = styled.div`
  margin: 64px 0;
`

export const StyledFakeLinkButton = styled(FakeLinkButton)`
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const Wrapper = styled.div`
  margin-top: 24px;
`

export const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
`

export const SearchWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const Table = styled(DefaultTable)`
  width: 100%;
` as typeof DefaultTable

export const IntegrationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const IntegrationIcon = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.B};
  border-radius: ${({ theme }) => theme.radii.medium};
  overflow: hidden;
`

export const IntegrationDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const IntegrationName = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const IntegrationStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`

export const ConnectedSection = styled.div<{ $showBorder: boolean }>`
  ${({ $showBorder, theme }) =>
    $showBorder &&
    `
    border-bottom: 1px solid ${theme.colors.border.A};
    margin-bottom: 8px;
    padding-bottom: 8px;
  `}
`

export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
  margin-bottom: 8px;
  padding-bottom: 8px;
`

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`

export const EmptyCell = styled(TableCell)`
  height: auto;

  &&&&& {
    background-color: transparent;
  }
`
export const EmptyRow = styled(TableRow)`
  height: auto;
`
